export function anthropometricMeasurementListByFilter() {
  return `{
  anthropometricMeasurementListByFilter(filter: {}) {
    id
    measureDate
    weight
    height
    headDiameter
    waistCircumference
    timelineIntegrationStatus
    student {
      id
      fullName
      dateOfBirth
      gender
      classesNames
      profilePhotoUrl
    }
  }
}
`;
}

export function anthropometricMeasurementListByStudent(studentId) {
  const query = `{ anthropometricMeasurementListByFilter(filter: { studentId:${studentId} }) {id, measureDate, weight, height, headDiameter, waistCircumference, student{id, fullName, dateOfBirth, gender, bloodType, classesNames, profilePhotoUrl
  }}
}`;
  return query;
}

export function anthropometricMeasurementListById(id) {
  const query = `{ anthropometricMeasurementListByFilter(filter: {id: ${id}}) {id, measureDate, weight, height, headDiameter, waistCircumference, student{id, fullName, dateOfBirth, gender, classesNames, profilePhotoUrl
  }}
}`;
  return query;
}

export function saveMutation(values) {
  const mutationQuery = `mutation { 
    anthropometricMeasurementSave(anthropometricMeasurement: {
        id: ${values.id ? values.id : 0},
        measureDate: ${values.measureDate.getTime()},
        weight: ${values.weight},
        height: ${values.height},
        headDiameter: ${values.headDiameter || 0},
        waistCircumference: ${values.waistCircumference || 0},
        student: { id: ${
          values.student.id
        }, filterByStatus:false, updaterId:0, active:false, legacyId:0, dateOfBirth:0, activeOnLoggedPeriod: false },
        filterByStatus: false, 
        updaterId: 0
    }){id}
}`;
  return mutationQuery;
}
export function removeWeightMeasureMutation(id) {
  const query = `mutation { 
      anthropometricMeasurementRemove(id: ${id}) }`;
  return query;
}

export function getAnthropometricMeasurementsById(id) {
  return `{
  anthropometricMeasurementListByFilter(filter: { id: ${id} }) {
    id
    measureDate
    weight
    height
    headDiameter
    waistCircumference
    student {
      fullName
      classesNames
    }
  }
}`;
}
